class PriorityQueue {
    heap: Array<{ value: any; priority: any}> = [];
    constructor() {
        this.heap = [];
    }

    parentIndex(index: number) {
        return Math.floor((index - 1) / 2);
    }

    leftChildIndex(index: number) {
        return index * 2 + 1;
    }

    rightChildIndex(index: number) {
        return index * 2 + 2;
    }

    enqueue(value: any, priority: any) {
        const node = { value, priority };
        this.heap.push(node);
        this.bubbleUp();
    }

    bubbleUp() {
        let index = this.heap.length - 1;
        while (index > 0) {
            const parentIdx = this.parentIndex(index);
            if (this.heap[index].priority >= this.heap[parentIdx].priority) break;

            [this.heap[index], this.heap[parentIdx]] = [this.heap[parentIdx], this.heap[index]];
            index = parentIdx;
        }
    }

    dequeue() {
        if (this.heap.length === 0) return null;
        if (this.heap.length === 1) return this.heap.pop()?.value ?? null;

        const root = this.heap[0].value;
        const last = this.heap.pop();
        if (last) {
            this.heap[0] = last;
            this.bubbleDown();
        }
        return root;
    }

    bubbleDown() {
        let index = 0;
        const length = this.heap.length;
        while (true) {
            const leftIdx = this.leftChildIndex(index);
            const rightIdx = this.rightChildIndex(index);
            let smallestIdx = index;

            if (leftIdx < length && this.heap[leftIdx].priority < this.heap[smallestIdx].priority) {
                smallestIdx = leftIdx;
            }
            if (rightIdx < length && this.heap[rightIdx].priority < this.heap[smallestIdx].priority) {
                smallestIdx = rightIdx;
            }
            if (smallestIdx === index) break;

            [this.heap[index], this.heap[smallestIdx]] = [this.heap[smallestIdx], this.heap[index]];
            index = smallestIdx;
        }
    }

    size() {
        return this.heap.length;
    }

    toArray() {
        return this.heap.map(node => node.value);
    }
}

export default PriorityQueue;